import clsx from 'clsx'

import Seo from '@/molecules/SEO/SEO'
import ElevatePageHero from './components/ElevatePageHero'
import ElevateSchedule from './components/ElevateSchedule'
import ElevateSpeakers from './components/ElevateSpeakers'
import ElevateInfo from './components/ElevateInfo'
import ElevateFooter from './components/ElevateFooter'
import ElevateProposition from './components/ElevateProposition'
import ElevateCMP from './components/ElevateCMP'

import { inter } from '@/styles/fonts/fonts'

function ElevatePageTemplate(): JSX.Element {
  return (
    <div className={clsx(inter.className, inter.variable)}>
      <Seo
        title="Global AI Virtual Content Summit 2023: Learn from Top Industry Experts | Pepper Content"
        canonical="/elevate-generative-ai/"
        meta={metadata}
      />
      <ElevatePageHero />
      <ElevateProposition />
      <ElevateSpeakers />
      <ElevateSchedule />
      <ElevateCMP />
      <ElevateInfo />
      <ElevateFooter />
    </div>
  )
}

const metadata = [
  {
    property: 'og:title',
    content:
      'Global AI Virtual Content Summit 2023: Learn from Top Industry Experts | Pepper Content'
  },
  {
    property: 'description',
    content:
      'Elevate is a virtual summit that brings together leading experts in content marketing globally. Join us as we look at content marketing through the lens of generative AI and explore its potential to transform businesses.'
  },
  {
    property: 'og:description',
    content:
      'Elevate is a virtual summit that brings together leading experts in content marketing globally. Join us as we look at content marketing through the lens of generative AI and explore its potential to transform businesses.'
  },
  {
    property: 'og:image',
    content: `${process.env.NEXT_PUBLIC_BASE_URL}/assets/elevate-generative-ai/images/elevate-og.png`
  }
]

export default ElevatePageTemplate
